import {
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { IStatusMessage, ResponseStatus } from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { Process } from '../../shared';
import { ExpenseItem } from '../store/expense-item.model';
import { DisplayErrors } from '../../shared/errors-sidenav';

@Component({
    selector: 'ef-expense-item-presenter',
    templateUrl: './expense-item-presenter.component.html',
    styleUrls: ['./expense-item-presenter.component.scss'],
    standalone: false
})
export class ExpenseItemPresenterComponent
    extends DisplayErrors<ExpenseItem>
    implements OnInit, OnDestroy {
    SelectedErrorSubject = new ReplaySubject<IStatusMessage>(1);
    private ExpenseItemSubject = new ReplaySubject<Array<ExpenseItem>>(1);
    private _expenseitems: Array<ExpenseItem>;
    @Input() set expenseItems(value: Array<ExpenseItem>) {
        if (value) {
            this._expenseitems = value;
            this.ExpenseItemSubject.next(value);
        }
    }
    get expenseItems(): Array<ExpenseItem> {
        return this._expenseitems;
    }

    @Input() public process: Process;

    active = true;

    @Output() LoadExpenseItems = new ReplaySubject<any>(1);
    @Output() SaveExpenseItems = new ReplaySubject<any>(1);

    constructor(@Inject(LoggingService) private log: LoggingService) {
        super();
    }

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this.active = false;
    }

    setupSubscriptions() {
        this.log.verbose({
            type: 'ExpenseItemPresenterComponent:setupSubscriptions'
        });
    }

    IsExpenseEntryChecked($event, rowData) {
        this.SaveExpenseItems.next([
            {
                EIListID: rowData.EIListID,
                IsExpenseEntry: rowData.IsExpenseEntry
            }
        ]);
    }
}
